import { render, staticRenderFns } from "./PropostaForm.vue?vue&type=template&id=461dc46b&scoped=true&"
import script from "./PropostaForm.vue?vue&type=script&lang=js&"
export * from "./PropostaForm.vue?vue&type=script&lang=js&"
import style0 from "./PropostaForm.vue?vue&type=style&index=0&id=461dc46b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dc46b",
  null
  
)

export default component.exports